import React, { useState, useEffect } from "react";
import { Collapse, Container, NavbarToggler, NavLink } from "reactstrap";
import Scrollspy from "react-scrollspy";

//import images
import logoLight from "../assets/images/logo-light.png";
import logoDark from "../assets/images/logo-dark.png";
import { Link } from "react-router-dom";

const NavBar = ({isDark}) => {
  const [isOpenMenu, setisOpenMenu] = useState(false);
  const [navClass, setnavClass] = useState("");

  const toggle = () => setisOpenMenu(!isOpenMenu);

  useEffect(() => {
    const scrollToHash = () => {
      const hash = window.location.hash;
      if (hash) {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    };

    // Delay the scroll to ensure DOM elements are rendered
    setTimeout(scrollToHash, 100);

    window.addEventListener("scroll", scrollNavigation, true);
  });

  function scrollNavigation() {
    var scrollup = document.documentElement.scrollTop;
    if (scrollup > 50) {
      setnavClass("nav-sticky");
    } else {
      setnavClass("");
    }
  }

  const isDarkClass = isDark ? "navbar-light" : "";

//   console.log('isOpenMenu: ', isOpenMenu);
//   console.log('navClass: ', navClass);

  return (
    <React.Fragment>
      <span>
        <nav
          className={
            "navbar navbar-expand-lg fixed-top " + 
            // "navbar navbar-expand-lg " + 
            isDarkClass +
            " sticky " +
            navClass
          }
          id="navbar"
        >
          <Container>
            <Link className="navbar-brand logo text-uppercase" to="/">
              {isDark ? (
                <>
                  <img
                    src={logoDark}
                    className="logo-light"
                    alt=""
                    height="44"
                  />
                  <img
                    src={logoDark}
                    className="logo-dark"
                    alt=""
                    height="44"
                  />
                </>
              ) : (
                <>
                  <img
                    src={logoDark}
                    className="logo-dark"
                    alt=""
                    height="44"
                  />
                  <img
                    src={logoLight}
                    className="logo-light"
                    alt=""
                    height="44"
                  />
                </>
              )}
            </Link>
            <NavbarToggler
              className="navbar-toggler"
              type="button"
              onClick={toggle}
            >
              <i className="mdi mdi-menu"></i>
            </NavbarToggler>
            <Collapse
              isOpen={isOpenMenu}
              className="navbar-collapse"
              id="navbarNav"
            >
              <Scrollspy
                offset={-18}
                items={[
                  "home",
                  "services",
                  "about",
                  "blogs",
                  "products",
                  "contact",
                  "Careers"
                ]}
                currentClassName="active"
                className="navbar-nav ms-auto navbar-center"
                id="mySidenav"
              >
                <li className="nav-item">
                  <NavLink href="/#home">Home</NavLink>
                </li>
                <li className="nav-item">
                  <NavLink href="/#services">Services</NavLink>
                </li>
                <li className="nav-item">
                  <NavLink href="/#about">About</NavLink>
                </li>
                <li className="nav-item">
                  <NavLink href="/#blog">Blogs</NavLink>
                </li>
                <li className="nav-item">
                  <NavLink href="/#products">Products</NavLink>
                </li>
                <li className="nav-item">
                  <NavLink href="/#team">Team</NavLink>
                </li>
                <li className="nav-item">
                  <NavLink href="/#contact">Contact</NavLink>
                </li>
                <li className="nav-item">
                  <NavLink href="/#careers">Careers</NavLink>
                </li>
                {/* <li className="nav-item">
                  <NavLink href="#testimonial">Testimonial</NavLink>
                </li>
                <li className="nav-item">
                  <NavLink href="#pricing">Pricing</NavLink>
                </li> */}
              </Scrollspy>
            </Collapse>
          </Container>
        </nav>
      </span>
    </React.Fragment>
  );
};

export default NavBar;
